import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { AuthGuard } from './auth/auth-guar.service';

const appRoutes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full', canActivate: [AuthGuard] },
  { path: 'companies', loadChildren: './pages/companies/companies.module#CompaniesModule', canActivate: [AuthGuard] },
  { path: 'dashboard', loadChildren: './pages/dashboard/dashboard.module#DashboardModule', canActivate: [AuthGuard] },
  { path: 'pending-registration', loadChildren: './pages/pending-registration/pending-registration.module#PendingModule', 
    canActivate: [AuthGuard] },
  { path: 'login', component:  LoginComponent, canActivate: [] },
];



@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {useHash: true, preloadingStrategy: PreloadAllModules}),
  ],

  providers: [
    AuthGuard
  ],

  exports: [
    RouterModule,
  ],
})

export class AppRoutingModule {}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/app-routing.module.ts